import React, { useState, useMemo } from 'react'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import { mediaLoaderStyles, mediaPageNavStyles } from './media-loader.styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretCircleLeft } from '@fortawesome/pro-solid-svg-icons/faCaretCircleLeft'
import { faCaretCircleRight } from '@fortawesome/pro-solid-svg-icons/faCaretCircleRight'

const useMediaNav = media => {
  const [activeMediaIndex, setActiveMediaIndex] = useState(0)
  const activeMedia = useMemo(() => {
    if (!media) return null
    return media[activeMediaIndex] || null
  }, [media, activeMediaIndex])
  const showNextMedia = () => {
    if (media) {
      setActiveMediaIndex(
        activeMediaIndex === media.length - 1 ? 0 : activeMediaIndex + 1
      )
    }
  }
  const showPrevMedia = () => {
    if (media) {
      setActiveMediaIndex(
        activeMediaIndex === 0 ? media.length - 1 : activeMediaIndex - 1
      )
    }
  }
  const mediaLength = !media ? 0 : media.length
  return {
    activeMedia,
    activeMediaIndex,
    setActiveMediaIndex,
    showNextMedia,
    showPrevMedia,
    mediaLength
  }
}

const MediaLoader = injectSheet(mediaLoaderStyles)(
  ({ classes, media, className, ...props }) => {
    return (
      <img
        className={classNames(classes.img, className)}
        width={media.width}
        height={media.height}
        alt="Work media"
        key={media.image_url}
        src={media.image_url}
        {...props}
      />
    )
  }
)

const MediaPageNav = injectSheet(mediaPageNavStyles)(
  ({ classes, mediaNav, className }) => {
    return (
      <div className={classNames(classes.container, className)}>
        <button onClick={mediaNav.showPrevMedia}>
          <FontAwesomeIcon icon={faCaretCircleLeft} />
        </button>
        <span>
          {mediaNav.activeMediaIndex + 1} / {mediaNav.mediaLength}
        </span>
        <button onClick={mediaNav.showNextMedia}>
          <FontAwesomeIcon icon={faCaretCircleRight} />
        </button>
      </div>
    )
  }
)

export { MediaLoader, MediaPageNav, useMediaNav }
